import { Box, Button, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SortIcon from "@mui/icons-material/Sort";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SearchBar } from "./SearchBar";
import { sidebarMenu } from "../common/constants/commonFunction";
import { layoutStyle } from "../pages/layout-ui/style";
import { TAB_CONTENT, TAB_VALUE } from "../common/constants/popupMessage";
import { ReplacementYearCount } from "./ReplacementYearCount";
import { PopupBlock } from "./PopupBlock";
import { PageNameConstant } from "../common/constants/PageNameConstant";
import { localStorageItemNames } from "../common/constants";
import { useUser } from "../common/hooks";
import {
  getActiveSortRecord,
  onSortChanged,
} from "../common/utils/sortingColumn";
import { columnSortingMessage } from "../common/utils/columnSortingMessage";
import { SortingTextPopup } from "../components/SortingTextPopup";
import { DEALEAR_DEFAULT } from "../common/constants/dealer-name";

export const ReplacementHeaderButton = ({
  onSearch,
  setSelectedNav,
  countYear,
  columnChange,
  movableColumnData,
  setMovableColumnData,
  movableColumn,
  updateViewMovableColumn,
  createMovableColumn,
  setColumnChange,
  gridRef,
  columnFinal,
  sortedColumn,
  sortableColumnData,
  setSortedColumn,
  setColumnFinal,
  createSortableColumn,
  updateViewSortableColumn,
  pageName,
  onResetReplacement,
  refreshData,
}) => {
  const navigation = useNavigate();
  const classes = layoutStyle();
  const { popupBlock, setPopupBlock } = useUser();
  const [prevButton, setPrevButton] = useState("");
  const [nextButton, setNextButton] = useState("");
  const [openSortingPopup, setOpenSortingPopup] = useState(false);

  const handleNext = (event) => {
    sessionStorage.removeItem("initialReplacementSchedule");
    if (columnChange) {
      setPopupBlock(true);
      setNextButton("/maintenance-repair-cost-comparison");
    } else {
      setSelectedNav(sidebarMenu.maintenance);
      navigation("/maintenance-repair-cost-comparison");
    }
  };
  const handleBack = () => {
    sessionStorage.removeItem("initialReplacementSchedule");
    if (columnChange) {
      setPopupBlock(true);
      setPrevButton("/current-fleet-details");
    } else {
      setSelectedNav(sidebarMenu.fleetList);
      navigation("/current-fleet-details");
    }
  };

  const handleAddButton = () => {
    sessionStorage.removeItem("initialReplacementSchedule");
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FLEET_LIST,
        selectedContent: TAB_CONTENT.FLEET_LIST,
      },
    });
  };
  const handleMovableColumn = async () => {
    const cols = gridRef.current?.api?.getAllGridColumns();
    const colNamesIndex = cols?.map((items, index) => items?.colDef);
    if (columnFinal?.length > 0) {
      colNamesIndex?.map((items, index) => (items.sort = null));
    }
    setMovableColumnData(colNamesIndex);
    if (movableColumn?.length > 0) {
      const response = await updateViewMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.replacementSchedule,
        ColumnName: JSON.stringify(colNamesIndex),
        id: movableColumn[0]?.id,
        SortedColumn: JSON.stringify(columnFinal),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
      if (response) {
        refreshData?.();
      }
    } else {
      const response = await createMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.replacementSchedule,
        ColumnName: JSON.stringify(colNamesIndex),
        SortedColumn: JSON.stringify(columnFinal),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
      if (response) {
        refreshData?.();
      }
    }
    setColumnChange(false);
  };
  const onSortedColumnChange = async () => {
    if (sortableColumnData?.length) {
      setOpenSortingPopup(true);
      return;
    }
    await onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      pageName
    );
  };
  const onSortedColumnChangeAlready = onSortedColumnChange;

  return (
    <Box>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Box className={classes.headerNameText}>Strategic Replacement Plan</Box>
        <Box className={classes.sortingFieldText}>
          {columnSortingMessage(sortableColumnData)}
        </Box>
      </Stack>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <ReplacementYearCount classes={classes} countYear={countYear} />
        <Box className={classes.addEditGrid}>
          {getActiveSortRecord(sortableColumnData) ? (
            <Button
              variant="contained"
              className={classes.replacementButtonAction}
              onClick={onSortedColumnChangeAlready}
              startIcon={<SortIcon style={{ fontSize: 15 }} />}
            >
              <span style={{ fontSize: 12 }}>Save Sort</span>
            </Button>
          ) : (
            <Button
              variant="contained"
              className={classes.replacementButtonAction}
              onClick={onSortedColumnChange}
              startIcon={<SortIcon style={{ fontSize: 15 }} />}
            >
              <span style={{ fontSize: 12 }}>Save Sort</span>
            </Button>
          )}
          <Button
            variant="contained"
            className={classes.replacementButtonAction}
            onClick={handleMovableColumn}
            startIcon={<ViewWeekIcon style={{ fontSize: 15 }} />}
          >
            <span style={{ fontSize: 12 }}>Save Columns</span>
          </Button>
          <Button
            variant="outlined"
            className={classes.replacementButtonSecondary}
            onClick={handleBack}
            startIcon={<ArrowBackIcon style={{ fontSize: 15 }} />}
          >
            <span style={{ fontSize: 12 }}>Back</span>
          </Button>
          <Button
            variant="contained"
            className={classes.replacementButtonPrimary}
            onClick={handleNext}
            endIcon={<ArrowForwardIcon style={{ fontSize: 15 }} />}
          >
            <span style={{ fontSize: 12 }}>Next</span>
          </Button>
          <Button
            variant="contained"
            className={classes.replacementButtonSuccess}
            onClick={handleAddButton}
            startIcon={<AddIcon style={{ fontSize: 15 }} />}
          >
            NEW
          </Button>
          {pageName === PageNameConstant.replacementSchedule && (
            <Button
              variant="outlined"
              className={classes.replacementButtonDanger}
              onClick={onResetReplacement}
            >
              Reset
            </Button>
          )}
          <SearchBar onSearch={onSearch} />
        </Box>
        {popupBlock && (
          <PopupBlock
            open={popupBlock}
            setOpen={() => setPopupBlock(false)}
            navigationRouteNext={nextButton}
            navigationRoutePrev={prevButton}
            selectedNavStyle={
              nextButton ? sidebarMenu.maintenance : sidebarMenu.fleetList
            }
            columnChangeData={movableColumnData}
            pageName={PageNameConstant.replacementSchedule}
          />
        )}
        {openSortingPopup && (
          <SortingTextPopup
            open={openSortingPopup}
            setOpen={setOpenSortingPopup}
            gridRef={gridRef}
            setSortedColumn={setSortedColumn}
            setColumnFinal={setColumnFinal}
            columnFinal={columnFinal}
            sortableColumnData={sortableColumnData}
            createSortableColumn={createSortableColumn}
            updateViewSortableColumn={updateViewSortableColumn}
            pageName={PageNameConstant.replacementSchedule}
          />
        )}
      </Stack>
    </Box>
  );
};
